import React from 'react';

const contactReasons = [
  'Customer support and general platform enquiries',
  'Service provider onboarding and partnership interest',
  'Press, research, and showcase-related enquiries',
  'Careers, collaboration, and product conversations',
];

export default function ContactPage() {
  return (
    <main style={{ background: '#f8fafc', color: '#0f172a', minHeight: '100vh' }}>
      <section
        style={{
          padding: '72px 24px 56px',
          background: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            maxWidth: '1080px',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '24px',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <p
              style={{
                margin: 0,
                color: '#4f46e5',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                fontSize: '0.9rem',
              }}
            >
              Contact us
            </p>

            <h1 style={{ margin: 0, fontSize: '3rem', lineHeight: 1.08, maxWidth: '11ch' }}>
              Get in touch with the HnB team
            </h1>

            <p style={{ margin: 0, color: '#475569', lineHeight: 1.8, fontSize: '1.05rem' }}>
              This page should become the main public contact surface for customers,
              providers, collaborators, and stakeholders who want to connect with HnB.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {contactReasons.map((item) => (
                <div
                  key={item}
                  style={{
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'flex-start',
                    background: '#f8fafc',
                    border: '1px solid #e5e7eb',
                    borderRadius: '14px',
                    padding: '14px 16px',
                  }}
                >
                  <div
                    style={{
                      width: '10px',
                      height: '10px',
                      marginTop: '7px',
                      borderRadius: '999px',
                      background: '#4f46e5',
                      flexShrink: 0,
                    }}
                  />
                  <p style={{ margin: 0, color: '#334155', lineHeight: 1.7 }}>{item}</p>
                </div>
              ))}
            </div>
          </div>

          <div
            style={{
              background: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '20px',
              padding: '24px',
              boxShadow: '0 10px 30px rgba(15, 23, 42, 0.05)',
            }}
          >
            <form style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontWeight: 600 }}>Full name</label>
                <input
                  type="text"
                  placeholder="Enter your name"
                  style={{
                    padding: '12px 14px',
                    borderRadius: '10px',
                    border: '1px solid #d1d5db',
                    outline: 'none',
                  }}
                />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontWeight: 600 }}>Email</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  style={{
                    padding: '12px 14px',
                    borderRadius: '10px',
                    border: '1px solid #d1d5db',
                    outline: 'none',
                  }}
                />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontWeight: 600 }}>Subject</label>
                <select
                  style={{
                    padding: '12px 14px',
                    borderRadius: '10px',
                    border: '1px solid #d1d5db',
                    outline: 'none',
                    background: '#ffffff',
                  }}
                >
                  <option>General enquiry</option>
                  <option>Provider onboarding</option>
                  <option>Partnership</option>
                  <option>Careers</option>
                  <option>Support</option>
                </select>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontWeight: 600 }}>Message</label>
                <textarea
                  rows={6}
                  placeholder="Write your message"
                  style={{
                    padding: '12px 14px',
                    borderRadius: '10px',
                    border: '1px solid #d1d5db',
                    outline: 'none',
                    resize: 'vertical',
                  }}
                />
              </div>

              <button
                type="button"
                style={{
                  background: '#111827',
                  color: '#ffffff',
                  border: 'none',
                  padding: '13px 18px',
                  borderRadius: '10px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                Send enquiry
              </button>
            </form>
          </div>
        </div>
      </section>

      <section style={{ padding: '56px 24px 72px' }}>
        <div
          style={{
            maxWidth: '1080px',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: '16px',
          }}
        >
          <div
            style={{
              background: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '18px',
              padding: '20px',
            }}
          >
            <h2 style={{ margin: '0 0 10px 0', fontSize: '1.1rem' }}>General contact</h2>
            <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.7 }}>
              Add your public email, telephone number, and standard response expectations here.
            </p>
          </div>

          <div
            style={{
              background: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '18px',
              padding: '20px',
            }}
          >
            <h2 style={{ margin: '0 0 10px 0', fontSize: '1.1rem' }}>Provider partnerships</h2>
            <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.7 }}>
              Use this area for provider onboarding, salon interest, and business partnership enquiries.
            </p>
          </div>

          <div
            style={{
              background: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '18px',
              padding: '20px',
            }}
          >
            <h2 style={{ margin: '0 0 10px 0', fontSize: '1.1rem' }}>Research and showcase</h2>
            <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.7 }}>
              This section can support investor, academic, pilot, or demonstration conversations around HnB.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}